import { LITE_TRADE_ORDER_STATUSES } from "../../liteTradeConstants";

export const LITE_TRADE_NOTIFICATION_STATUSES = {
    ATTENTION: 'attention',
    SUCCESS: 'success',
    WARNING: 'warning',
}

export const LITE_TRADE_NOTIFICATION_TYPES = {
    LIQUIDATION: 'liquidation',
    MARGIN_CALL: 'margin_call',
    ORDER_CANCELED: 'order_canceled',
    ORDER_CHANGED: 'order_changed',
    ORDER_CREATED: 'order_created',
    ORDER_REJECTED: 'order_rejected',
    POSITION_CLOSED: 'position_closed',
    POSITION_OPENED: 'position_opened',
    POSITION_PARTIALLY_CLOSED: 'position_partially_closed',
}

export const MAP_LITE_TRADE_ORDER_STATUS_TO_ORDER_NOTIFICATION_TYPE = {
    [LITE_TRADE_ORDER_STATUSES.CANCELED]: LITE_TRADE_NOTIFICATION_TYPES.ORDER_CANCELED,
    [LITE_TRADE_ORDER_STATUSES.REJECTED]: LITE_TRADE_NOTIFICATION_TYPES.ORDER_REJECTED,
    [LITE_TRADE_ORDER_STATUSES.WORKING]: LITE_TRADE_NOTIFICATION_TYPES.ORDER_CREATED,
}
